import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { logsReducer } from './reducers/logsReducer'
import { usersReducer } from './reducers/usersReducer'

const intialState = {}
const appReducer = combineReducers({
    users: usersReducer,
    logs: logsReducer
})

const reducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action)
    }
    return appReducer(state, action)
}

const composeEnhancer = window._REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
    reducer,
    intialState,
    composeEnhancer(applyMiddleware(thunk))
)

export default store